import React from 'react';
import { ReactComponent as WarningIcon } from '@repo/common/assets/icons/32px/icon_32px_info_filled.svg';
import { applyTypography } from '@repo/common';

const Precautions = () => {
  const descriptionTypo = applyTypography('b14');
  const descriptionTitle =
    'Pathport 주의 사항 텍스트 Pathport 주의 사항 텍스트 Pathport 주의 사항 텍스트 Pathport 주의 사항 텍스트 Pathport 주의 사항 텍스트  Pathport 주의 사항 텍스트 Pathport 주의 사항 텍스트 Pathport 주의 사항 텍스트 \nPathport 주의 사항 텍스트 Pathport 주의 사항 텍스트 Pathport 주의 사항 텍스트 Pathport 주의 사항 텍스트 Pathport 주의 사항 텍스트 Pathport 주의 사항 텍스트';

  return (
    <div
      className='flex flex-row items-start w-full h-full overflow-clip
                    px-4 pt-[60px] pb-[320px] gap-3
                    tabletH:px-20 tabletH:pt-20 tabletH:pb-[380px] tabletH:gap-3
                    desktopL:px-20 desktopL:pt-20 desktopL:pb-[500px] desktopL:gap-3'
    >
      <WarningIcon
        className='text-grayscale-gray04 shrink-0 size-5 tabletH:size-8'
        aria-hidden='true'
      />
      <span
        className={`flex-[1_0_0] min-h-0 min-w-0 ${descriptionTypo} text-grayscale-gray04 whitespace-pre-wrap`}
      >
        {descriptionTitle}
      </span>
    </div>
  );
};

export default Precautions;
